import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenominationReports = ({
  denominationId,
  page,
  pageSize,
  startDate,
  endDate
}) => {
  return axios.get(
    `/denominations/${denominationId}/report?page=${page}&per_page=${pageSize}&start_date=${startDate}&end_date=${endDate}`
  );
};

export const useDenominationReports = ({
  denominationId,
  page,
  pageSize,
  startDate,
  endDate,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "denomination-reports",
      denominationId,
      page,
      pageSize,
      startDate,
      endDate
    ],
    queryFn: () =>
      getDenominationReports({
        denominationId,
        page,
        pageSize,
        startDate,
        endDate
      })
  });
};
